<template>
  <div class="rastermap">
    <div class="row no-gutters" v-if="title">
      <div class="col">
        <h4>Hydrological Overview</h4>
      </div>
    </div>

    <div class="row no-gutters cmd" style="border-top:1px dashed #ddd;display:none;">
      <div class="col-sm-auto text-left">
        <a class="btn btn-sm btn-command" href="#" @click.prevent="switchBackground"><i class="fas fa-hand-point-up"></i> Switch Background</a>
        
      </div>
      <div class="col text-right">
        
      </div>
    </div>


    <div class="row no-gutters justify-content-end">

    </div>
    <div class="row row-eq-height no-gutters">
      <div class="col-sm-9">
        <div ref="map" class="map"></div>
      </div>
      <div class="col-sm-3" style="padding:7px;padding-top:0px;">
        <div style="padding:0px;border:0px solid #ccc;;z-index:99999999999999;position:relative;background-color:#fff;">
          <div ref="mapUpstream" class="map" style="width:100%;"></div>

        </div>
      </div>
    </div>

    <div class="row no-gutters">

      <div v-bind:class="descriptionClass">
        <div class="legend-wrapper">
          <slot></slot>
        </div>
      </div>
      <div class="col-sm-3 col-md-3 col-lg-3">
      <div class="legend-wrapper">
          <p style="color:#888;">
            Inset (above) shows full upstream watersheds for catchments and subcatchments that overlap the area of interest.
          </p>
          </div>
      </div>
    </div>

    <div class="row no-gutters" v-if="attribution">
      <p class="attribution">{{attribution}}</p>
    </div>


  </div>

</template>

<script>
/* eslint-disable */
import Leaflet from 'leaflet';
import "leaflet/dist/leaflet.css";
import omnivore from "@mapbox/leaflet-omnivore";
import _ from 'lodash'; 

export default {
    name: 'HydrologyMap',
    components: { },
    props: ['location', 'source', 'title', 'description', 'layout', 'attribution', 'factsheet', 'loaded'],
    data() {
        return {
            background: 'OpenStreetMap',
            legend: null
        }
    },
    mounted() {
      var backgroundUrl = process.env.VUE_APP_API+'/tools/layer/'+this.background+'/v1?z={z}&x={x}&y={y}'

      this.map = L.map(this.$refs.map, { 
        'attributionControl': false, 
        'scrollWheelZoom': false }
      );
      this.map.createPane('boundariesPane')
      this.map.getPane('boundariesPane').style.zIndex = 201;
      this.map.getPane('boundariesPane').style.pointerEvents = 'none';

      this.map.createPane('topPane')
      this.map.getPane('topPane').style.zIndex = 99999999999;

      L.control.scale().addTo(this.map);
      this.mapBackground = L.tileLayer(backgroundUrl, {
        attribution: '',
        maxZoom: 18,
        id: 'mapBackground'
      }).addTo(this.map);

      /* Initialize the upstream map */
      this.mapUpstream = L.map(this.$refs.mapUpstream, { 
          'attributionControl': false, 
          'zoomControl': false,
          'scrollWheelZoom': false,
          'keyboard': false,
          'tap': false,
          'touchZoom': false,
          'dragging': false,
          'boxZoom': false
         }
      );
      this.mapUpstreamBackground = L.tileLayer(backgroundUrl, {
        attribution: '',
        maxZoom: 18,
        id: 'mapBackgroundUpstream'
      }).addTo(this.mapUpstream);

      this.loadMap()
    },
    watch: {
      loaded() {
        this.loadMap();
        //this.loadLegend();
      }
    },
    methods: {
      loadMap() {

        L.GeoJSON.include({
          highlight: function(hybas_id) {
            this.eachLayer(function(layer) {
              if(hybas_id == layer._hybas_id) {
                layer.setStyle({'fillOpacity': 0.3, 'opacity':0.3});
                var next_up = layer.feature.properties.next_up
                for (var i=0; i<next_up.length; ++i) {
                    this.highlight(next_up[i])
                }
              }
              
            }, this)
          },
          lowlight: function() {
            this.eachLayer(function(layer) {
                layer.setStyle({'fillOpacity': 0, 'opacity':1});
            });
          }
        })


        if(this.location.bounds) {
          var dataset_id = this.factsheet.dataset_ids['hydrobasins']
          var dataset_path = this.factsheet.dataset_paths['hydrobasins'];

          var upstreamUrl = process.env.VUE_APP_API+'/data/factsheet'+dataset_path+'/hydrosheds_upstream.geojson';

          this.$axios.get(upstreamUrl).then((response) => {
            var opts = {
                style: function(layer) {
                  const colors = ["#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf"]
                  return {
                    "color": "#fff",
                    "fillColor": colors[layer.properties.ix % 10],
                    "weight": 1,
                    "opacity": 1,
                    "fillOpacity": 0.15
                  }
                },
                interactive: false
            }
            this.upstream = new L.geoJSON(response.data, opts).addTo(this.mapUpstream);

            this.mapUpstream.fitBounds(this.upstream.getBounds());

            _.cloneDeep(this.location.layer).addTo(this.mapUpstream);

          });


          /* Load Rivers */
          //var riversUrl = process.env.VUE_APP_API+'/data/factsheet/'+this.factsheet['identifier']+'/data/'+dataset_id+'/rivers.geojson';
          var riversUrl = process.env.VUE_APP_API+'/data/factsheet'+dataset_path+'/rivers.geojson';
          this.$axios.get(riversUrl).then((response) => {
            var opts = {
                style: function(layer) {
                  var weight = 1;
                  try { var weight = parseInt(layer.properties.class.substr(1,1)) }
                  catch {}
                  return {
                      "color": "#007bff",
                      "fillColor": "#007bff",
                      "weight": 1,
                      "opacity": 1,
                      "fillOpacity": 0
                    }
                  },
                  pane: 'boundariesPane',
                  interactive: false
                }

            this.rivers = new L.geoJSON(response.data, opts).addTo(this.map);
          });

          /* Load divisions */
          //var divisionsUrl = process.env.VUE_APP_API+'/data/factsheet/'+this.factsheet['identifier']+'/data/'+dataset_id+'/divisions.geojson';
          var divisionsUrl = process.env.VUE_APP_API+'/data/factsheet'+dataset_path+'/divisions.geojson';
          this.$axios.get(divisionsUrl).then((response) => {
            var opts = {
                style: function(layer) {
                  const colors = ["#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf"]
                  return {
                    "color": "#fff",
                    "fillColor": colors[layer.properties.ix % 10],
                    "weight": 1,
                    "opacity": 1,
                    "fillOpacity": 0.15
                  }
                },
                pane: 'boundariesPane',
                interactive: false
            }
            this.divisions = new L.geoJSON(response.data, opts).addTo(this.map);
          });



          /* Load basins */
          //var basinsUrl = this.factsheet.baseUrl+'/data/'+dataset_id+'/hydrobasins.geojson';
          //var basinsUrl = process.env.VUE_APP_API+'/data/factsheet/'+this.factsheet['identifier']+'/data/'+dataset_id+'/hydrobasins.geojson';
          var basinsUrl = process.env.VUE_APP_API+'/data/factsheet'+dataset_path+'/hydrobasins.geojson';
          this.$axios.get(basinsUrl).then((response) => {
              var opts = {
                pane: 'boundariesPane',
                style: function(layer) {
                  const colors = ["#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf"]
                  return {
                    "fillColor": colors[layer.properties.ix % 10],
                    "opacity":1,
                    "weight": 1,
                    "color":"#fff",
                    "fillOpacity": 0
                  }
                },
                onEachFeature: function (feature, layer) {
                  layer._hybas_id = feature.properties.id
                  // layer.on('mouseover', function () {
                  //   //feature.highlight();
                  // });
                  // layer.on('mouseout', function () {
                  //   // this.setStyle({
                  //   //   "color": "#007bff",
                  //   //   "fillColor": "#007bff",
                  //   //   "weight": 0,
                  //   //   "opacity": 1,
                  //   //   "fillOpacity": 0.15
                  //   // });
                  // });

                  // layer.on('click', function () {
                  //   // Let's say you've got a property called url in your geojsonfeature:
                  //   window.location = feature.properties.url;
                  // });
                }
              }

              this.hydrolayer = new L.geoJSON(response.data, opts).addTo(this.map);


          /* Load dams */
          //var damsUrl = this.factsheet.baseUrl+'/data/hydrobasins/dams.geojson';
          //var damsUrl = process.env.VUE_APP_API+'/data/factsheet/'+this.factsheet['identifier']+'/data/'+dataset_id+'/dams.geojson';
          var damsUrl = process.env.VUE_APP_API+'/data/factsheet'+dataset_path+'/dams.geojson';
          this.$axios.get(damsUrl).then((response) => {
            var opts = {
                pointToLayer: function (feature, latlng) {
                  return L.circleMarker(latlng, {
                    radius: 5,
                    fillColor: "#e50000",
                    weight: 0,
                    fillOpacity: 1
                  });
                },
                pane: 'topPane',
                interactive: false
            }
            this.dams = new L.geoJSON(response.data, opts).addTo(this.map).bringToFront();
          });

              //this.map.fitBounds(this.hydrolayer.getBounds());

              this.hydrolayer.on("mouseover", function(e) {
                this.lowlight()
                this.highlight(e.layer._hybas_id)
              });
          })

          _.cloneDeep(this.location.layer).addTo(this.map);
          this.map.fitBounds(this.location.bounds);



        }
      },
      hideData() {
        this.data.setOpacity(0.3)
      },
      showData() {
        this.data.setOpacity(1)
      },
      switchBackground() {
        console.log("current="+this.background)
        this.background = (this.background == 'cjm2jwo1033ho2sqngqh1263v') ? 'ckg19vj6j2yv719nieoymrgaq' : 'cjm2jwo1033ho2sqngqh1263v'
        console.log("swticed to: "+this.background)
      }
    },
    computed: {
      downloadUrl() {
        //return this.$api.data+'/location/'+this.location.uuid+'/data'+this.source;
        return ''
      },
      legendClass() {
        return "col-sm-12 col-md-12 col-lg-"+(this.layout ? this.layout.legendWidth : 6)
      },
      descriptionClass() {
        return "col-sm-12 col-md-12 col-lg-"+(this.layout ? this.layout.descriptionWidth : 6)
      }

    }
}
</script>


<style scoped>
div.rastermap {
  margin:10px 0px 10px 0px;
}
h4 {
  margin:0px;
  padding:8px;
  padding-left:10px;
  font-size:0.9em;
  width:100%;
  color:#444;
}
h5 {
  font-size:0.7em;
  color:#666;
  font-weight:600;
  padding:5px 0px 10px 0px;
  margin:0px;

}
p {
  margin:0px;
  font-size:0.6em;
  color:#222;
  padding-bottom:10px;
}
p.attribution {
  font-size:0.5em;
  padding:0px 6px 3px 6px;
  color:#888;
}
div.cmd, div.row {
  background-color:#f5f5f5;
}
a.btn-command:focus, a.btn-command:active {
  outline:none !important;
  box-shadow:none;
} 
a.btn-command {
  background-color:#f5f5f5;
  color:#999;
}
a.btn-command:hover {
  background-color:#eeeeee;
  color:#777;
}
a.btn-command i {
  font-size:0.8em;
}
div.legend-wrapper {
  padding:7px;
}
</style>